<button
  type="button"
  class="checkout-btn"
  [class.checkout-btn--disabled]="cartStore.items.length === 0 || disabled"
  (click)="onClick()"
>
  <ng-content></ng-content>
</button>
